import axios from 'axios';
import store from './store';
import router from './router';

const proxy = axios.create({});

if (location.hostname === 'localhost' || location.hostname === '127.0.0.1') {
    proxy.defaults.baseURL = 'http://localhost:5000';
    proxy.defaults.filesBaseURL = 'http://localhost:5000';
} else if (location.host.indexOf('46.242.129.10:8891') >= 0) {
    //proxy.defaults.baseURL = 'https://api.infoforum.pl';
    //proxy.defaults.filesBaseURL = 'https://api.infoforum.pl';
    proxy.defaults.baseURL = 'http://46.242.129.10:8889';
    proxy.defaults.filesBaseURL = 'http://46.242.129.10:8889';
} else {
    proxy.defaults.baseURL = 'https://api.infoforum.pl';
    proxy.defaults.filesBaseURL = 'https://api.infoforum.pl';
    //proxy.defaults.baseURL = 'http://46.242.129.10:8889';
    //proxy.defaults.filesBaseURL = 'http://46.242.129.10:8889';
}

proxy.interceptors.request.use(config => {

    let token = store.getters["user/token"];

    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
});

proxy.interceptors.response.use(
    response => {
        return response
    },
    async error => {
        let errorMsg = "Error";
        let errorData;
        if (error.response) {
            errorData = error.response.data;
        } else {
            errorMsg = error;
            return new Promise((resolve, reject) => {
                // eslint-disable-next-line no-console
                console.log(errorMsg);
                reject(errorMsg);
            });
        }

        if (error.response.status == 401) {
            localStorage.clear();
            await store.dispatch('user/logout');
            store.commit('conference/resetCurrent');
            router.push({name: 'main'});
        } else if (error.response.status == 403) {
            await store.dispatch('user/refreshProfile');
            router.push({name: 'main'});
        }


        // tak, wielkosc znakow jest gdzies skopana..... Message z wielkiej, errors z malej
        if (errorData.Message) {
            errorMsg = errorData.Message;
        } else if (errorData.errors) {
            let tempMsg = "";
            for (var p in errorData.errors) {
                for (var pp in errorData.errors[p]) {
                    tempMsg += errorData.errors[p][pp] + '<br />';
                }
            }
            errorMsg = tempMsg;
        } else if (errorData) {
            if (errorData.title) {
                errorMsg = errorData.title;
            } else {
                errorMsg = errorData;
            }

        }

        return new Promise((resolve, reject) => {
            // eslint-disable-next-line no-console
            console.log(errorMsg);
            reject(errorMsg);
        });
    }
);


proxy.downloadFileAsync = async function (id) {
    const response = await proxy.get("/files/download", {
        responseType: "arraybuffer",
        params: {
            id: id
        }
    });

    return response.data;
};

proxy.getFileUrl = function (id) {
    return `${this.defaults.filesBaseURL}/files/download?id=${id}`;
};

proxy.getAttendeeAvatarUrl = function (confYear, confType, id) {
    return `${this.defaults.filesBaseURL}/files/download/avatar?conferenceYear=${confYear}&conferenceType=${confType}&id=${id}`;
};

proxy.getThematicPathIconUrl = function (name) {
    name = encodeURI(name);
    return `${this.defaults.filesBaseURL}/files/download/thematic-path?name=${name}`;
};

proxy.getUserAvatarUrl = function (externalId) {
    if (externalId == null) return require("@/assets/img/blank_avatar.png");
    ;
    return `${this.defaults.baseURL}/files/download/avatar?id=${externalId}`;
};

proxy.downloadAgendaFile = async function (url, params) {
    try {
        var response = await proxy.get(url,
            {
                responseType: "blob",
                params: params
            }
        );

        let link = document.createElement("a");
        link.setAttribute("type", "hidden");
        link.href = window.URL.createObjectURL(response.data);

        link.download = "Agenda.pdf";
        document.body.appendChild(link);
        link.click();
        link.remove();
    } catch (err) {
        // eslint-disable-next-line no-console
        console.log(err);
    } finally {
    }

};

export default proxy;
